<template>
  <div>
    <div class="modals">
      <b-modal
        class="modalNotif"
        :modal-class="true ? 'in':''"
        :hide-header-close="true"
        :title-tag="'h4'"
        cancel-title="Annuler"
        id="modalNotif"
        ref="modal"
        title="Mises à jour récentes"
        @ok="handleOk"
      >
        <div class="row">
          <div class="col-md-12">
            <div class=" well"
                 v-for="maj in getMajNixinut"
                 :key="maj.id">
              <h1>{{ maj.title }}</h1>
              <p v-html="maj.content"></p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1 id="vue">
          Tableau de bord
          <small>Bonjour {{ getMainUser.name }}</small>
        </h1>
      </section>

      <section class="content">

        <!-- RACCOURCIS RAPIDES -->
        <div class="row">
          <div class="col-md-12">
            <div class="dashboard-quick-actions">
              <router-link to="/add-member" class="btn btn-default btn-quick-action">
                <i class="fa fa-user-plus"></i> Nouveau membre
              </router-link>
              <router-link to="/add-club" class="btn btn-default btn-quick-action">
                <i class="fa fa-plus-circle"></i> Nouveau club
              </router-link>
              <router-link :to="{ name: 'Recap', params: { recap_id: 0 }}" class="btn btn-default btn-quick-action">
                <i class="fa fa-file-text-o"></i> Nouveau récap
              </router-link>
              <router-link :to="{ name: 'Competition', params: { competition_id: 0 }}" class="btn btn-default btn-quick-action">
                <i class="fa fa-trophy"></i> Nouvelle compétition
              </router-link>
              <router-link :to="{ name: 'Formation', params: { formation_id: 0 }}" class="btn btn-default btn-quick-action">
                <i class="fa fa-graduation-cap"></i> Nouvelle formation
              </router-link>
            </div>
          </div>
        </div>

        <!-- KPI CARDS -->
        <div class="row dashboardGraphs">
          <div class="col-sm-6">
            <div class="info-box">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <span class="info-box-icon bg-aqua">
                <i class="fa fa-users"></i>
              </span>
              <div class="info-box-content">
                <span class="info-box-text">Membres licenciés en {{ getDate() }}</span>
                <div class="info-box-number">{{ chartdataMembres.misc.nombre }}
                  <span class="info-box-percent"
                    :class="{'text-red':chartdataMembres.misc.percent<0,'text-green':chartdataMembres.misc.percent>=0}">
                    <i :class="chartdataMembres.misc.percent>=0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    {{ chartdataMembres.misc.percent }}%
                  </span>
                </div>
                <span class="info-box-text text-sm">{{ chartdataMembres.misc.difference }} par rapport à {{ getDate() - 1 }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="info-box">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <span class="info-box-icon bg-green">
                <i class="fa fa-check-circle"></i>
              </span>
              <div class="info-box-content">
                <span class="info-box-text">En ordre aujourd'hui</span>
                <div class="info-box-number">{{ chartdataMembres.misc.nombreToday }}
                  <span class="info-box-percent"
                    :class="{'text-red':chartdataMembres.misc.percentToday<0,'text-green':chartdataMembres.misc.percentToday>=0}">
                    <i :class="chartdataMembres.misc.percentToday>=0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    {{ chartdataMembres.misc.percentToday }}%
                  </span>
                </div>
                <span class="info-box-text text-sm">{{ chartdataMembres.misc.nombreTodayAnneePassee }} à la même date en {{ getDate() - 1 }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="info-box">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <span class="info-box-icon bg-yellow">
                <i class="fa fa-building"></i>
              </span>
              <div class="info-box-content">
                <span class="info-box-text">Clubs licenciés en {{ getDate() }}</span>
                <div class="info-box-number">{{ chartdataClubs.misc.nombre }}
                  <span class="info-box-percent"
                    :class="{'text-red':chartdataClubs.misc.percent<0,'text-green':chartdataClubs.misc.percent>=0}">
                    <i :class="chartdataClubs.misc.percent>=0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    {{ chartdataClubs.misc.percent }}%
                  </span>
                </div>
                <span class="info-box-text text-sm">{{ chartdataClubs.misc.difference }} par rapport à {{ getDate() - 1 }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="info-box">
              <div class="overlay" v-if="loadingStats">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <span class="info-box-icon bg-purple" style="background-color: #605ca8 !important;">
                <i class="fa fa-euro"></i>
              </span>
              <div class="info-box-content">
                <span class="info-box-text">Montant récaps {{ getDate() }}</span>
                <div class="info-box-number">{{ montantTotalAnneeEnCours | currency }}<span class="info-box-percent"
                    :class="{'text-red':percentMontant<0,'text-green':percentMontant>=0}"
                    v-if="montantTotalAnneePrecedente > 0">
                    <i :class="percentMontant>=0 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    {{ percentMontant }}%
                  </span>
                </div>
                <span class="info-box-text text-sm">{{ montantTotalAnneePrecedente | currency }} sur la même période en {{ getDate() - 1 }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ALERTES -->
        <div class="row">
          <div class="col-md-6">
            <DashboardAlertes></DashboardAlertes>
          </div>
        </div>

        <!-- GRAPHIQUES -->
        <div class="row">
          <div class="col-md-6">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title"><i class="fa fa-line-chart"></i> Montant des récapitulatifs (cumul)</h3>
              </div>
              <div class="box-body">
                <LineChartjsDashboard
                  v-if="!loadingStats"
                  :chartdata="chartdataMontantsSomme"
                ></LineChartjsDashboard>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title"><i class="fa fa-bar-chart"></i> Montant des récapitulatifs (par mois)</h3>
              </div>
              <div class="box-body">
                <LineChartjsDashboard
                  v-if="!loadingStats"
                  :chartdata="chartdataMontants"
                ></LineChartjsDashboard>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  </div>
</template>

<script type="text/babel">
import BarChartjsDashboard from "./Outils/BarChartjsDashboard";
import LineChartjsDashboard from "./Outils/LineChartjsDashboard";
import DashboardAlertes from "./DashboardAlertes";
import {mapGetters, mapActions} from 'vuex'
import _ from 'lodash'

// var _ = require('underscore')
var moment = require('moment')
export default {
  data() {
    return {
      stats: null,
      montantTotalAnneeEnCours: 0,
      montantTotalAnneePrecedente: 0,
      colors: ['#ffb91d', '#f97817', '#6de304', '#ff0000', '#732bea', '#c913ad',
        '#e32d91', '#c830cc', '#4ea6dc', '#4775e7', '#8971e1', '#d54773',
        '#af5b5b', '#4800ff', '#276fbf', '#183059',
        '#ff7f00',
        '#ff4500',
        '#32cd32',
        '#ff1493',
        '#8a2be2',
        '#d02090',
        '#ff69b4',
        '#da70d6',
        '#87ceeb',
        '#6495ed',
        '#9370db',
        '#ff6eb4',
        '#cd5c5c',
        '#4169e1',
        '#1e90ff',
        '#1c1c1c',
      ],
      loadingStats: true,
      chartdataMontants: {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: []
      },
      chartdataMontantsSomme: {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: []
      },
      chartdataMembres: {
        misc: {
          nombre: 0,
          percent: 0,
          difference: 0,
          licenciesDansClubsNonLicencies: 0
        },
        labels: [],
        datasets: []
      },
      chartdataClubs: {
        misc: {
          nombre: 0,
          percent: 0,
          difference: 0,
        },
        labels: [],
        datasets: []
      },
      chartdataMembresRapport: {
        misc: {
          nombre: 0,
          nombreAnPasse: 0,
          percent: 0,
          difference: 0,
        },
        labels: [],
        datasets: []
      },
    }
  },
  methods: {
    ...mapActions({
      setMajNixinut: 'setMajNixinut',
    }),
    showModal() {
      if (this.getMajNixinut && this.getMajNixinut.length > 0)
        this.$bvModal.show('modalNotif')
      else
        this.$bvModal.hide('modalNotif')
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()

      let self = this;
      this.$http.post(this.getRoute('setMajNixinutRead'),
        {"ids_notifications": this.getMajNixinut.map((item) => item.id)}
      )
        .then(function (response) {
          $('#modalNotif').modal('hide')
          self.setMajNixinut(null)
        }, (response) => {
          self.$noty.error("Erreur serveur")
          $('#modalNotif').modal('hide')
        });

      // this.saveProfile()
      // this.$bvModal.hide('modalNotif')
    },

    getCurrentDate: function (yearsToSubstract = 0) {
      return moment().subtract(yearsToSubstract, 'years').format('DD/MM/YYYY')
    },
    getStatsClub: async function (force = false) {
      let self = this;
      this.loadingStats = true
      await this.$http.get(this.getRoute('Statistiques.getStatistiquesForDashboard')).then((response) => {
        this.stats = response.body
        // console.log(response)
        //C'EST MOCHE
        // setTimeout(() => {
        if (
          this.getChartDataForMembre() &&
          this.getChartDataForMembreRapportAnneePasse() &&
          this.getChartDataForClub() &&
          this.getChartDataForMontants() &&
          this.getChartDataForMontantsEnSomme()
        )
          this.loadingStats = false
        // }, 2000);
      }, (response) => {
      });
    },
    getChartDataForMembre: function () {
      this.chartdataMembres.datasets.push({
        label: 'Membres affiliés par année',
        backgroundColor: '#FFF',
        data: []
      })

      this.stats.membres.forEach((item, index, array) => {
        if (item.annee == moment().year()) {
          let percent = ((100 - (item.nombre * 100 / array[index - 1].nombre)) * -1).toFixed(2);
          let percentToday = ((100 - (item.nombreToday * 100 / array[index - 1].nombreToday)) * -1).toFixed(2);
          let difference = item.nombre - array[index - 1].nombre
          let differenceToday = item.nombreToday - array[index - 1].nombreToday
          this.chartdataMembres.misc = {
            nombre: item.nombre,
            nombreToday: item.nombreToday,
            nombreTodayAnneePassee: array[index - 1].nombreToday,
            percent: percent,
            percentToday: percentToday,
            difference: difference,
            differenceToday: differenceToday,
            licenciesDansClubsNonLicencies: Math.abs(item.ADEPS - item.nombreLicences),
          }
        }
        this.chartdataMembres.labels.push(item.annee);
        this.chartdataMembres.datasets[0].data.push(item.nombre)
      })
      return true
    },
    getChartDataForMembreRapportAnneePasse: function () {
      this.chartdataMembresRapport.datasets.push({
        label: 'Progression des inscriptions par rapport à l\'année passée',
        backgroundColor: '#FFF',
        data: []
      })

      this.stats.membres_rapport_annee_passee.forEach((item, index, array) => {
        if (item.annee == moment().year()) {
          let percent = ((100 - (item.nombre * 100 / array[index - 1].nombre)) * -1).toFixed(2);
          let difference = item.nombre - array[index - 1].nombre
          this.chartdataMembresRapport.misc = {
            nombre: item.nombre,
            nombreAnPasse: array[index - 1].nombre,
            percent: percent,
            difference: difference,
          }
        }
        this.chartdataMembresRapport.labels.push(moment(item.date).format('DD/MM/YYYY'));
        this.chartdataMembresRapport.datasets[0].data.push(item.nombre)
      })
      return true
    },
    getChartDataForClub: function () {
      this.chartdataClubs.datasets.push({
        label: 'Clubs affiliés par année',
        backgroundColor: '#FFF',
        data: []
      })

      this.stats.clubs.forEach((item, index, array) => {
        if (item.annee == moment().year()) {
          let percent = ((100 - (item.nombre * 100 / array[index - 1].nombre)) * -1).toFixed(2);
          let difference = item.nombre - array[index - 1].nombre
          this.chartdataClubs.misc = {
            nombre: item.nombre,
            percent: percent,
            difference: difference,
          }
        }
        this.chartdataClubs.labels.push(item.annee);
        this.chartdataClubs.datasets[0].data.push(item.nombre)
      })
      return true
    },
    getChartDataForMontants: function () {
      this.chartdataMontants.datasets = []
      //     label: 'Montants par année',
      //     backgroundColor: '#FFF000',
      //     data: []
      // })
      let monthCurrent = 1;
      let yearPrec = 0;
      let toPush = {}
      this.stats.montantsByYearByMonth.forEach((item, index, array) => {
        if (yearPrec != item.annee) {
          if (yearPrec != 0)
            this.chartdataMontants.datasets.push(toPush)
          yearPrec = item.annee
          monthCurrent = 1;
          let color = this.getColor()
          toPush = {
            label: item.annee,
            borderColor: this.hexToRGB(color, 1),
            backgroundColor: this.hexToRGB(color, 0.1),
            data: []
          }
        }
        if (monthCurrent != item.mois) {
          for (let i = monthCurrent; i < item.mois; i++) {
            monthCurrent++
            toPush.data.push(0)
          }
        }

        if (monthCurrent == item.mois) {
          toPush.data.push(Math.round(item.somme))
          monthCurrent++
        }
        if (index == array.length - 1)
          this.chartdataMontants.datasets.push(toPush)
      })
      // console.log(this.chartdataMontants.datasets)
      return true
    },
    getMontantRecapsToDate: function () {
      let self = this
      this.$http.get(this.getRoute('Statistiques.getMontantRecapsToDate')).then((response) => {
        let data = response.body
        self.montantTotalAnneeEnCours = Math.round(data.annee_courante.montant) || 0
        self.montantTotalAnneePrecedente = Math.round(data.annee_precedente.montant) || 0
      }, () => {})
    },
    getChartDataForMontantsEnSomme: function () {
      this.chartdataMontantsSomme.datasets = []
      let monthCurrent = 1;
      let yearPrec = 0;
      let sommeByMonthYear = 0;
      let toPush = {}

      this.stats.montantsByYearByMonth.forEach((item, index, array) => {
        if (yearPrec != item.annee) {
          if (yearPrec != 0)
            this.chartdataMontantsSomme.datasets.push(toPush)
          yearPrec = item.annee
          monthCurrent = 1;
          sommeByMonthYear = 0;
          let color = this.getColor()
          toPush = {
            label: item.annee,
            borderColor: this.hexToRGB(color, 1),
            backgroundColor: this.hexToRGB(color, 0.1),
            data: []
          }
        }
        if (monthCurrent != item.mois) {
          for (let i = monthCurrent; i < item.mois; i++) {
            monthCurrent++
            toPush.data.push(sommeByMonthYear)
          }
        }

        if (monthCurrent == item.mois) {
          sommeByMonthYear = sommeByMonthYear + Math.round(item.somme)
          toPush.data.push(sommeByMonthYear)
          monthCurrent++
        }
        if (index == array.length - 1)
          this.chartdataMontantsSomme.datasets.push(toPush)
      })
      return true
    },
    hexToRGB: function (hex, alpha) {
      let r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
      } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
      }
    },
    getColor: function () {
      let color = this.colors[0];
      this.colors.shift();
      return color;
    },
    getDifference: function () {
      return 0
    },
    getDate: function (today = false) {
      return today ? moment().format('DD/MM/YYYY') : moment().year()
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getMajNixinut: 'getMajNixinut',
      getMainUser: 'getMainUser',
    }),
    percentMontant() {
      if (this.montantTotalAnneePrecedente === 0) return 0
      return ((100 - (this.montantTotalAnneeEnCours * 100 / this.montantTotalAnneePrecedente)) * -1).toFixed(2)
    }
  },
  filters: {
    currency: function (value) {
      if (!value && value !== 0) return ''
      return new Intl.NumberFormat('fr-BE', {style: 'currency', currency: 'EUR', maximumFractionDigits: 0}).format(value)
    }
  },
  components: {
    BarChartjsDashboard: BarChartjsDashboard,
    LineChartjsDashboard: LineChartjsDashboard,
    DashboardAlertes: DashboardAlertes,
  },
  watch: {
    getMajNixinut: function () {
      this.showModal()
    }
  },
  mounted() {
    this.getStatsClub();
    this.getMontantRecapsToDate();
    // this.showModal()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue